<template>
    <div>
        <CRow>
            <CCol sm="12">
                <CCard>
                    <CCardHeader>
                        <strong>افزودن کاربر</strong>
                    </CCardHeader>
                    <CCardBody>
                        <CForm @keyup.enter="validator();submit()">
                            <CRow>
                                <CCol sm="3">
                                    <CInput v-model="form.first_name.val" :description="form.first_name.inv" label="نام" />
                                </CCol>
                                <CCol sm="3">
                                    <CInput v-model="form.last_name.val" :description="form.last_name.inv" label="نام خانوادگی" />
                                </CCol>
                                <CCol sm="3">
                                    <CInput v-model="form.fathername.val"  :description="form.fathername.inv" label="نام پدر" />
                                </CCol>
                                <CCol sm="3">
                                    <CInput v-model="form.national_code.val" :description="form.national_code.inv" dir="ltr" label="کد ملی" />
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol sm="3">
                                    <CInput v-model="form.shenasname_no.val" :description="form.shenasname_no.inv" dir="ltr" label="شماره شناسنامه" />
                                </CCol>
                                <CCol sm="3">
                                    <label>محل تولد</label>
                                    <model-select :options="all_cities" v-model="form.tavalod_city.val" placeholder="انتخاب کنید"></model-select>
                                </CCol>
                                <CCol sm="3">
                                    <label>تاریخ تولد</label>
                                    <date-picker placeholder="انتخاب کنید" v-model="form.tavalod_date.val"></date-picker>
                                </CCol>
                                <CCol sm="3">
                                    <CInput v-model="form.email.val" :description="form.email.inv" dir="ltr" label="ایمیل" />
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol sm="3">
                                    <CInput v-model="form.username.val" :description="form.username.inv" dir="ltr" label="شماره موبایل" />
                                </CCol>
                                <CCol sm="3">
                                    <CInput v-model="form.tell.val" :description="form.tell.inv" dir="ltr" label="شماره تلفن" />
                                </CCol>
                                <CCol sm="3">
                                    <CInput v-model="form.fax.val" :description="form.fax.inv" dir="ltr" label="فکس" />
                                </CCol>
                                <CCol sm="3">
                                    <CInput type="password" v-model="form.password.val" :description="form.password.inv" dir="ltr" label="رمز عبور" />
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol sm="3">
                                    <CSelect label="استان" :options="provinces" v-model="form.ostan_id.val" placeholder="انتخاب کنید" @change="get_counties($event.target.value)" />
                                </CCol>
                                <CCol sm="3">
                                    <CSelect label="شهرستان" :options="counties" v-model="form.county_id.val" placeholder="انتخاب کنید" @change="get_cities($event.target.value)" />
                                </CCol>
                                <CCol sm="3">
                                    <CSelect label="شهر" :options="cities" v-model="form.city_id.val" placeholder="انتخاب کنید" @change="form.city_id.val=$event.target.value" />
                                </CCol>
                                <CCol sm="3">
                                    <CInput v-model="form.postcode.val" :description="form.postcode.inv" dir="ltr" label="کد پستی" />
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol sm="6">
                                    <CInput v-model="form.address.val" :description="form.address.inv" label="آدرس" />
                                </CCol>
                                <CCol sm="3">
                                    <CInput v-model="form.link.val" :description="form.link.inv" dir="ltr" label="لینک دریافت" />
                                </CCol>
                                <CCol sm="3">
                                    <CSelect label="کاربر حقوقی" v-model="form.is_hoghoghi.val" :options="[{value: 'true', label:'بله'}, {value: 'false', label: 'خیر'}]" @change="form.is_hoghoghi.val=$event.target.value" />
                                </CCol>
                            </CRow>
                            <CRow v-if="form.is_hoghoghi.val=='true'">
                                <CCol sm="3">
                                    <CSelect v-model="form.sherkat_type.val" label="نوع شرکت" :options="[
                                        {value: '1', label:'سهامی عام'},
                                        {value: '2', label:'سهامی خاص'},
                                        {value: '3', label:'مسئولیت محدود'},
                                        {value: '4', label:'تضامنی'},
                                        {value: '5', label:'مختلط غیرسهامی'},
                                        {value: '6', label:'مختلط سهامی'},
                                        {value: '7', label:'نسبی'},
                                        {value: '8', label:'تعاونی'},
                                        {value: '9', label:'دولتی'},
                                        {value: '10', label:'وزارتخانه'},
                                        {value: '11', label:'سفارتخانه'},
                                        {value: '12', label:'مسجد'},
                                        {value: '13', label:'مدرسه'},
                                        {value: '14', label:'NGO'},]"
                                        placeholder="انتخاب کنید"
                                        @change="form.sherkat_type.val=$event.target.value" />
                                </CCol>
                                <CCol sm="3">
                                    <CInput v-model="form.sherkat_name.val" :description="form.sherkat_name.inv" label="نام شرکت" />
                                </CCol>
                                <CCol sm="3">
                                    <CInput v-model="form.sherkat_sabt_num.val" :description="form.sherkat_sabt_num.inv" dir="ltr" label="شماره ثبت شرکت" />
                                </CCol>
                                <CCol sm="3">
                                    <label>تاریخ ثبت شرکت</label>
                                    <date-picker placeholder="انتخاب کنید" v-model="form.sherkat_sabt_date.val"></date-picker>
                                </CCol>
                            </CRow>
                            <CRow v-if="form.is_hoghoghi.val=='true'">
                                <CCol sm="3">
                                    <CInput v-model="form.sherkat_shenase_melli.val" :description="form.sherkat_shenase_melli.inv" dir="ltr" label="شناسه ملی شرکت" />
                                </CCol>
                                <CCol sm="3">
                                    <CInput v-model="form.sherkat_code_eghtesadi.val" :description="form.sherkat_code_eghtesadi.inv" dir="ltr" label="کد اقتصادی شرکت" />
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol sm="3" v-show="$store.state.perms.can_verify_user">
                                    <CSelect label="تایید کاربر" v-model="form.is_verified.val" :options="[{value: 'true', label:'فعال'}, {value: 'false', label: 'غیرفعال'}]" placeholder="انتخاب کنید" @change="form.is_verified.val=$event.target.value" />
                                </CCol>
                                <CCol sm="3" v-show="$store.state.perms.can_active_and_deactive_user">
                                    <CSelect v-model="form.is_active.val" label="وضعیت" :options="[{value: 'true', label:'فعال'}, {value: 'false', label: 'غیرفعال'}]" placeholder="انتخاب کنید" @change="form.is_active.val=$event.target.value" />
                                </CCol>
                                <CCol sm="3" v-show="$store.state.perms.can_add_users_to_user_group">
                                    <label>گروه کاربری</label>
                                    <model-select :options="user_groups" v-model="form.user_group_id.val" placeholder="انتخاب کنید">
                                    </model-select>
                                </CCol>
                                <CCol sm="3" v-show="$store.state.perms.can_update_user_access_web_service_state">
                                    <CSelect label="دسترسی به وب‌سرویس" v-model="form.access_web_service.val" :options="[{value: 'true', label:'فعال'}, {value: 'false', label: 'غیرفعال'}]" placeholder="انتخاب کنید" @change="form.access_web_service.val=$event.target.value" />
                                </CCol>
                            </CRow>
                        </CForm>
                        <br>
                        <div class="form-group form-actions">
                            <CButton @click="validator();submit()" color="primary">افزودن</CButton>
                        </div>
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
    </div>
</template>

<script>
import { ModelSelect } from 'vue-search-select'
import validator from '../mixins'
export default {
    mixins: { validator },
    components: { ModelSelect },
    data() {
        return {
            form: {
                first_name: {val: '', inv: '', v: {max: 64}},
                last_name:  {val: '', inv: '', v: {max: 64}},
                fathername:  {val: '', inv: '', v: {max: 64}},
                national_code:  {val: '', inv: '', v: {max: 16}},
                shenasname_no:  {val: '', inv: '', v: {max: 16}},
                tavalod_city:  {val: '', inv: '', v: {max: 8}},
                tavalod_date:  {val: '', inv: '', v: {max: 16}},
                email:  {val: '', inv: '', v: {max: 64, spec: 'email'}},
                username:  {val: '', inv: '', v: {max: 16, req: true, spec: 'mobile'}},
                tell:  {val: '', inv: '', v: {max: 16}},
                fax:  {val: '', inv: '', v: {max: 16}},
                password:  {val: '', inv: '', v: {max: 64, req: true, spec: 'password',}},
                ostan_id:  {val: '', inv: '', v: {max: 8}},
                county_id: {val: '', inv: '', v: {max: 8}},
                city_id:  {val: '', inv: '', v: {max: 8}},
                postcode:  {val: '', inv: '', v: {max: 16}},
                address:  {val: '', inv: '', v: {max: 256}},
                link: {val: '', inv: '', v: {max: 256}},
                is_hoghoghi: {val: 'false', inv: '', v: {max: 8}},
                sherkat_type:  {val: '', inv: '', v: {max: 8}},
                sherkat_name:  {val: '', inv: '', v: {max: 64}},
                sherkat_sabt_num:  {val: '', inv: '', v: {max: 16}},
                sherkat_sabt_date:  {val: '', inv: '', v: {max: 16}},
                sherkat_shenase_melli:  {val: '', inv: '', v: {max: 16}},
                sherkat_code_eghtesadi:  {val: '', inv: '', v: {max: 16}},
                is_verified:  {val: '', inv: '', v: {max: 8}},
                is_active:  {val: '', inv: '', v: {max: 8}},
                user_group_id: {val: '', inv: '', v: {max: 8}},
                access_web_service:  {val: '', inv: '', v: {max: 8}},
            },
            disable: false,
            provinces: [],
            counties: [],
            cities: [],
            all_cities: [],
            user_groups: [],
        }
    },
    mounted() {
        this.get_provinces();
        this.get_all_cities();
        this.get_user_groups();
    },
    methods: {
        get_provinces() {
            this.axios.get('provinces/')
                .then(res => {
                    res.data.map(val => {
                        this.provinces.push({ value: val.id.toString(), label: val.name });
                    });
                })
        },
        get_counties(id) {
            this.form.ostan_id.val = id;
            this.counties = [];
            this.cities = [];
            this.axios.get('counties/'
                + '?province_id=' + id)
                .then(res => {
                    res.data.map(val => {
                        this.counties.push({ value: val.id.toString(), label: val.name });
                    });
                })
        },
        get_cities(id) {
            this.form.county_id.val = id;
            this.cities = [];
            this.axios.get('cities/'
                + '?county_id=' + id)
                .then(res => {
                    res.data.map(val => {
                        this.cities.push({ value: val.id.toString(), label: val.name });
                    });
                })
        },
        get_all_cities() {
            this.axios.get('cities/')
                .then(res => {
                    res.data.map(val => {
                        this.all_cities.push({ value: val.id.toString(), text: val.name });
                    });
                })
        },
        get_user_groups() {
            this.axios.get('user_groups/')
                .then(res => {
                    res.data.map(val => {
                        this.user_groups.push({ value: val.id, text: val.name });
                    });
                })
        },
        submit(){
            if (this.disable == false) {
                const data = new FormData();
                data.set('username', this.form.username.val);
                data.set('password', this.form.password.val);
                data.set('first_name', this.form.first_name.val);
                data.set('last_name', this.form.last_name.val);
                data.set('email', this.form.email.val);
                data.set('is_active', this.form.is_active.val);
                data.set('city_id', this.form.city_id.val);
                data.set('address', this.form.address.val);
                data.set('postcode', this.form.postcode.val);
                data.set('national_code', this.form.national_code.val);
                data.set('is_verified', this.form.is_verified.val);
                data.set('access_web_service', this.form.access_web_service.val);
                data.set('is_hoghoghi', this.form.is_hoghoghi.val);
                if (this.form.is_hoghoghi == 'true') {
                    data.set('sherkat_type', this.form.sherkat_type.val);
                    data.set('sherkat_name', this.form.sherkat_name.val);
                    data.set('sherkat_sabt_num', this.form.sherkat_sabt_num.val);
                    if(this.form.sherkat_sabt_date.val != ''){
                        data.set('sherkat_sabt_date', this.$moment(this.form.sherkat_sabt_date.val, 'jYYYY-jMM-jDD').locale('es').format('YYYY-MM-DD'));
                    }
                    data.set('sherkat_shenase_melli', this.form.sherkat_shenase_melli.val);
                    data.set('sherkat_code_eghtesadi', this.form.sherkat_code_eghtesadi.val);
                    data.set('sherkat_rabet_firstname', this.form.first_name.val);
                    data.set('sherkat_rabet_lastname', this.form.last_name.val);
                    data.set('sherkat_rabet_name_pedar', this.form.fathername.val);
                    data.set('sherkat_rabet_code_melli', this.form.national_code.val);
                    data.set('sherkat_rabet_shomare_shenasname', this.form.shenasname_no.val);
                    if(this.form.tavalod_date.val != ''){
                        data.set('sherkat_rabet_tavalod_date', this.$moment(this.form.tavalod_date.val, 'jYYYY-jMM-jDD').locale('es').format('YYYY-MM-DD'));
                    }
                    data.set('sherkat_rabet_tavalod_city', this.form.tavalod_city.val);
                    data.set('sherkat_email', this.form.email.val);
                    data.set('sherkat_tell', this.form.tell.val);
                    data.set('sherkat_fax', this.form.fax.val);
                    data.set('sherkat_ostan', this.form.ostan_id.val);
                    data.set('sherkat_city', this.form.city_id.val);
                    data.set('sherkat_address', this.form.address.val);
                    data.set('sherkat_code_posti', this.form.postcode.val);
                } else {
                    data.set('fristname', this.form.first_name.val);
                    data.set('lastname', this.form.last_name.val);
                    data.set('fathername', this.form.fathername.val);
                    data.set('national_code', this.form.national_code.val);
                    data.set('shenasname_no', this.form.shenasname_no.val);
                    if(this.form.tavalod_date.val != ''){
                        data.set('tavalod_date', this.$moment(this.form.tavalod_date.val, 'jYYYY-jMM-jDD').locale('es').format('YYYY-MM-DD'));
                    }
                    data.set('tavalod_city', this.form.tavalod_city.val);
                    data.set('mobile_no', this.form.username.val);
                    data.set('email', this.form.email.val);
                    data.set('tell', this.form.tell.val);
                    data.set('fax', this.form.fax.val);
                    data.set('ostan_id', this.form.ostan_id.val);
                    data.set('city_id', this.form.city_id.val);
                    data.set('address', this.form.address.val);
                    data.set('post_code', this.form.postcode.val);
                }
                this.axios.post('users/', data)
                    .then(res => {
                        if (res.data.state == 'user_exist') {
                            this.$notify({
                                group: 'foo',
                                type: 'error',
                                text: 'کاربر موجود است.'
                            });
                        } else {
                            if (this.user_group_id != '') {
                                const data = new FormData();
                                data.set('user_id', res.data.id);
                                data.set('user_group_id', this.user_group_id);
                                this.axios.post('users_to_groups/', data)
                            }
                            if (this.link != '') {
                                const data = new FormData();
                                data.set('user_id', res.data.id);
                                data.set('url_link', this.link);
                                data.set('is_active', true)
                                this.axios.post('user_urls/', data)
                            }
                        }
                        this.$notify({
                            group: 'foo',
                            type: 'success',
                            text: 'افزودن با موفقیت انجام شد.'
                        });
                        for (const key in this.form) {
                            if(key != 'is_hoghoghi'){
                                this.form[key].val = '';
                            }
                        }
                        this.form.is_hoghoghi.val = 'false';
                    })
                    .catch(() => {
                        this.$notify({
                            group: 'foo',
                            type: 'error',
                            text: 'خطا! لطفا مجددا تلاش کنید.'
                        });
                    });
            }
        },
    },
	beforeCreate(){
        if(this.$store.state.perms.can_add_user == false
            && this.$store.state.verif == false){
			this.$router.push('/403')
		}
	},
}
</script>